import styles from "./MultipleChoiceQuestion.module.css";
import { useTranslation } from "react-i18next";


export default function MultipleChoiceQuestion({ options = [], value, onChange, details = {} }) {
    const { t } = useTranslation();
    const textFields = details.textFields || [];

    // Normalize incoming value
    let selectedIdx = [];
    let detailsMap = {};
    if (Array.isArray(value)) {
        // legacy selection by string -> map to indices (1-based)
        selectedIdx = value
            .map((v) => options.indexOf(v) + 1)
            .filter((i) => i > 0);
    } else if (value && typeof value === 'object') {
        selectedIdx = Array.isArray(value.choice) ? value.choice : [];
        detailsMap = (value.details && typeof value.details === 'object') ? value.details : {};
    }

    const emit = (nextSelected, nextDetails) => {
        onChange({ choice: nextSelected, details: nextDetails });
    };

    const toggle = (idx1) => {
        const set = new Set(selectedIdx);
        if (set.has(idx1)) set.delete(idx1); else set.add(idx1);
        const nextSelected = Array.from(set).sort((a, b) => a - b);
        emit(nextSelected, { ...detailsMap });
    };

    const handleDetailsChange = (idx1, text) => {
        emit([...selectedIdx], { ...detailsMap, [idx1]: text });
    };

    return (
        <div className={styles.wrap}>
            {options.map((opt, i) => {
                const idx1 = i + 1;
                const isChecked = selectedIdx.includes(idx1);
                const hasText = textFields.includes(idx1);
                const optLabel = typeof opt === 'object' && opt !== null ? opt.label : opt;
                return (
                    <div key={idx1} className={styles.row}>
                        <label className={styles.optionLabel}>
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => toggle(idx1)}
                            />
                            <span>{optLabel}</span>
                        </label>
                        {hasText && (
                            <input
                                type="text"
                                className={styles.detailsInput}
                                value={detailsMap[idx1] || ""}
                                onChange={(e) => handleDetailsChange(idx1, e.target.value)}
                                disabled={!isChecked}
                                placeholder={isChecked ? t("placeholder.textField") : ""}
                                aria-label={`${opt} details`}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
